import {
  PERMISSIONS_MODULES_ID,
  PERMISSIONS_OPTIONS_VALUE
} from 'constants/team-members';
import { DISCOUNTS_PERMISSIONS } from 'constants/permissions/discounts';
import { PAGES_PERMISSIONS } from 'constants/permissions/pages';
import { STORE_DESIGN_PERMISSIONS } from 'constants/permissions/store-design';
import { TEAM_MEMBERS_PERMISSIONS } from 'constants/permissions/team-members';
import { WALLET_PERMISSIONS } from 'constants/permissions/wallet';
import { APP_STORE_PERMISSIONS } from 'constants/permissions/app-store';
import { ONLINE_STORE_PERMISSIONS } from 'constants/permissions/online-store';
import { SETTINGS_PERMISSIONS } from 'constants/permissions/settings';
import { PRODUCTS_AND_CATEGORIES_PERMISSIONS } from 'constants/permissions/products-and-categories';
import { DELIVERIES_AND_PICKUPS_PERMISSIONS } from 'constants/permissions/deliveries-and-pickups';

const { NO_ACCESS } = PERMISSIONS_OPTIONS_VALUE;

const {
  DELIVERIES,
  PRODUCTS,
  DISCOUNTS,
  PAGES,
  STORE_DESIGN,
  APP_STORE,
  ONLINE_STORE,
  TEAM_MEMBERS,
  WALLET,
  SETTINGS
} = PERMISSIONS_MODULES_ID;

export const userHasTabAccess = (tabId, userSllrPermissions = {}) =>
  userSllrPermissions[tabId] && userSllrPermissions[tabId] !== NO_ACCESS;

export const getTeamMembersAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[TEAM_MEMBERS];

  return TEAM_MEMBERS_PERMISSIONS[access] || {};
};

export const getPagesAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[PAGES];

  return PAGES_PERMISSIONS[access] || {};
};

export const getWalletAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[WALLET];

  return WALLET_PERMISSIONS[access] || {};
};

export const getDiscountsAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[DISCOUNTS];

  return DISCOUNTS_PERMISSIONS[access] || {};
};

export const getStoreDesignAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[STORE_DESIGN];

  return STORE_DESIGN_PERMISSIONS[access] || {};
};

export const getAppStoreAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[APP_STORE];

  return APP_STORE_PERMISSIONS[access] || {};
};

export const getOnlineStoreAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[ONLINE_STORE];

  return ONLINE_STORE_PERMISSIONS[access] || {};
};

export const getSettingsAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[SETTINGS];

  return SETTINGS_PERMISSIONS[access] || {};
};

export const getProductsAndCategoriesAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[PRODUCTS];

  return PRODUCTS_AND_CATEGORIES_PERMISSIONS[access] || {};
};

export const getOrdersAndPickupsAccess = (userSllrPermissions = {}) => {
  const access = userSllrPermissions[DELIVERIES];

  return DELIVERIES_AND_PICKUPS_PERMISSIONS[access] || {};
};
